import Vue from 'vue';

export const apiService = {
  methods: {
    getList(kioskId, filters) {
      return Vue.http.get(
        `${process.env.BACKEND_API_URL}api/v2/kiosks/${kioskId}/permits?` +
        (filters.startDate ? `start_date=${filters.startDate}` : ``) +
        (filters.endDate ? `&end_date=${filters.endDate}` : ``) +
        (filters.vehicle_nr ? `&vehicle_reg=${filters.vehicle_nr}` : ``) +
        (filters.id_code ? `&id_code=${filters.id_code}` : ``) +
        `&state=${filters.state}` +
        `&permit_status=${filters.permit_status}`
      )
        .then((response) => {
          return response.body
        })
        .catch((response) => {
          return response
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tenants/kiosk-permits/api/services.js